import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { EmployeeServices } from './../employees/services/employee.services';
import { DepartmentDropDownResolver } from './../employees/services/employee.resolver.service';
import { VehicleEditComponent } from './components/vehicle-edit.component';
import {
  VehicleEditResolver,
  VehicleListResolver,
  VehicleFeaturesResolver,
  VehicleListResolverByUserResolver
} from './services/vehicle.resolver.service';
import { VehicleServices } from './services/vehicle.service';
import { VehicleComponent } from './vehicle.component';
import { VehicleListComponent } from './components/vehicleList.component';
import { VehicleFormComponent } from './components/vehicleForm.component';
import { VehicleViewComponent } from './components/vehicle-view.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { RouterModule } from '@angular/router';
import { EcplTabNavigationModule } from 'src/app/shared/ecpl-tab-navigation/ecpl-tab-navigation.module';
import { VehicleHeaderListComponent } from './components/vehicle-header.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';

@NgModule({ exports: [
        VehicleListComponent,
        VehicleFormComponent,
        VehicleEditComponent,
        VehicleViewComponent,
        VehicleHeaderListComponent
    ],
    declarations: [
        VehicleListComponent,
        VehicleFormComponent,
        VehicleEditComponent,
        VehicleViewComponent,
        VehicleHeaderListComponent
    ],
  imports: [
    BrowserModule,
    TableModule,
    SharedModule,
    FormsModule,
        DatePickerModule,
    EditorModule,
    ContextMenuModule,
    MenuModule,
    DialogModule,
    ReactiveFormsModule,
        SelectModule,
        TextareaModule,
    InputTextModule,
    TranslatePipe, TranslateDirective,
    AppSharedModule,
    RouterModule,
    ButtonModule,
    EcplTabNavigationModule,
    KubaExportModule
  ],
  providers: [
    VehicleServices,
    VehicleEditResolver,
    VehicleListResolver,
    DepartmentDropDownResolver,
    EmployeeServices,
    VehicleFeaturesResolver,
    VehicleListResolverByUserResolver,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class VehicleModule {}
